import React, { FC } from 'react';
import { Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { usePopover } from '../../hooks';
import { Language, LanguageOptions, LanguagePopover } from './language-popover';
import { ArrowTooltip } from '../tooltips';

export const LanguageSwitch: FC = () => {
  const { i18n, t } = useTranslation();
  const popover = usePopover<HTMLButtonElement>();
  let text = LanguageOptions[i18n.language as Language];

  return (
    <>
      <ArrowTooltip title={t('language-picker.title')}>
        <Button
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          style={{
            color: "rgb(16, 185, 129)",
            textTransform: "none"
          }}
        >
          <Typography variant="caption">{
            text ? text : "Unknown"
          }</Typography>
        </Button>
      </ArrowTooltip>
      <LanguagePopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
